import React from 'react'
import T from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Box, Stack, Typography } from '@mui/material'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

import Tooltip from './Tooltip'

export default function CommentLink({
  label,
  commentsNumberLabel,
  commentsNumber,
  handleClick,
  contentIsReadOnly = false,
  advisory,
}) {
  const { t } = useTranslation()
  const style = contentIsReadOnly ? { cursor: 'not-allowed' } : {}

  return (
    <Stack direction="row" alignItems="center">
      <MailOutlineIcon fontSize="small" />
      <Box pr={1} />
      <Stack
        disabled={contentIsReadOnly}
        style={style}
        sx={{ cursor: 'pointer', minWidth: 150 }}
        onClick={contentIsReadOnly === false ? handleClick : undefined}
      >
        <Typography variant="body2">
          {label || t('carsToBuy.messages.leaveComment')}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {!!commentsNumber &&
            (commentsNumberLabel ||
              t(
                `carsToBuy.messages.comment${
                  commentsNumber > 1 ? 's' : ''
                }Left`,
                { number: commentsNumber }
              ))}
        </Typography>
      </Stack>
      {advisory && (
        <>
          <Box pr={2} />
          <InfoOutlinedIcon fontSize="small" />
          <Box pr={1} />
          <Typography variant="body2">{'Avviso:'}</Typography>
          <Box pr={0.5} />
          <Stack
            sx={{
              width: 0,
              flex: 1,
            }}
          >
            <Tooltip title={advisory} placement="top-end">
              <Typography
                variant="body2"
                style={{
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }}
                color="error"
              >
                {advisory}
              </Typography>
            </Tooltip>
          </Stack>
        </>
      )}
    </Stack>
  )
}

CommentLink.propTypes = {
  label: T.string,
  commentsNumberLabel: T.string,
  commentsNumber: T.number,
  handleClick: T.func,
  contentIsReadOnly: T.bool,
  showNotice: T.bool,
}
